var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasMoreImagesThanDisplayed)?_c('div',{staticClass:"component-more-images"},[_vm._v(" "+_vm._s(_vm.label)+"+ ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }